import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { State } from "../store/interfaces";

import { StatusCodes } from "http-status-codes";
import { LeadSourceService } from "../api/services/leadSource";
import { LeadSource } from "../api/models/leadSource";
import { loadLeadSourceErrorAction, loadLeadSourceRequestAction, loadLeadSourceSuccessAction } from "../store/reducers/leadSource";


export const useLeadSource = (
    leadSourceService: LeadSourceService
) => {
  const source = useSelector((state: State) => state.leadSource);

  const [updating, setUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | undefined>();
  const dispatch = useDispatch();

  const loadLeadSource = async () => {
    if (source.isLoading || source.isLoaded) {
      return;
    }
    dispatch(loadLeadSourceRequestAction());
    try {
      const response = await leadSourceService.loadAllLeadSource();

      return dispatch(loadLeadSourceSuccessAction(response));
    } catch (error) {
      return dispatch(loadLeadSourceErrorAction());
    }
  };

  const createLeadSource = async (
    data: LeadSource,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await leadSourceService.createLeadSource({
        ...data,
      });
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError("Unable to update details");
      }
    } catch (error) {
      setUpdateError("Unable to update details");
    }
    setUpdating(false);
  };

  const updateLeadSource = async (
    data: LeadSource,
    id?: string,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await leadSourceService.updateLeadSource(
        {
          ...data,
        },
        id
      );
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError("Unable to update details");
      }
    } catch (error) {
      setUpdateError("Unable to update details");
    }
    setUpdating(false);
  };

  return {
    loadLeadSource,
    createLeadSource,
    updateLeadSource,
    updating,
    updateError,
  };
};
